import React from 'react';
import ReactDOM from 'react-dom';
import 'flowbite';
import './index.css';
import Router from './lib/launcher/Router';

ReactDOM.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
  document.getElementById('root'),
);
